import React, { useEffect, useState } from "react";
import moment from "moment";
import QRCode from "react-qr-code";
function StudentInfo(props) {



  const [CurrentYear, setCurrentYear] = useState("");

  const RenderHTMLString = (htmlString) => {
    return <div dangerouslySetInnerHTML={{ __html: htmlString }} />;
  };

  useEffect(() => {
    //setFee(props.fee);

    const date = new Date();
    const year = date.getFullYear();
    setCurrentYear(year.toString());
  }, []);

  const arrayData = props.fee || [];

  const formatAmount = (value) => {
    if (value === null || value === undefined || value === "") return "";
    const amount = parseFloat(value);
    if (Number.isNaN(amount)) return value;
    return amount.toLocaleString("en-US");
  };

  const renderFeeDetail = () => {
    const rows = arrayData.filter((item) => (item.ReceiveableFee || 0) > 0);
    if (rows.length === 0) {
      return (
        <tr>
          <td
            colSpan={2}
            style={{ border: "1px solid #000000", padding: "4px", textAlign: "center" }}
          >
            No Fee Details
          </td>
        </tr>
      );
    }

    return rows.map((item, index) => (
      <tr key={index}>
        <td style={{ border: "1px solid #000000", padding: "4px" }}>
          {item.Description || item.FeeCode}
        </td>
        <td
          style={{
            border: "1px solid #000000",
            padding: "4px",
            textAlign: "right",
            width: "80px",
          }}
        >
          {formatAmount(item.ReceiveableFee)}
        </td>
      </tr>
    ));
  };

  const totalAmount = arrayData.reduce(
    (sum, item) => sum + (parseFloat(item.ReceiveableFee) || 0),
    0
  );

  // Parse FeeVoucherStatement (Account Title + Account No)
  const getAccountInfo = (statement) => {
    if (!statement) return null;

    const parts = statement.trim().split(" ");
    const accountNumber = parts[parts.length - 1];
    const accountTitle = parts.slice(0, -1).join(" ");

    return { accountTitle, accountNumber };
  };

  // Mask account number (first 7 + **** + last 5)
  const maskAccountNumber = (accNo) => {
    if (!accNo || accNo.length < 12) return accNo;
    // return accNo.slice(0, 7) + "****" + accNo.slice(-5);
    return accNo;
  };

  const accountData = getAccountInfo(props.bank);

  return (
    <>
      <div style={{ padding: "4px 0px 4px 0px" }}>
        <table style={{ width: "100%" }} cellSpacing={0} cellPadding={0}>
          <tbody>
            <tr>
              <td valign="top">
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div style={{ paddingRight: "8px" }}>
                    {props.school ? (
                      <div style={{ fontSize: "16px", fontWeight: "bold" }}>
                        {props.school}
                      </div>
                    ) : null}
                    {(props.schoolAddress || props.schoolPhone) ? (
                      <div style={{ fontSize: "10px" }}>
                        {props.schoolAddress}
                        {props.schoolAddress && props.schoolPhone ? " | " : ""}
                        {props.schoolPhone}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    {props.logo ? (
                      <img src={props.logo} style={{ width: "80px", height: "auto" }} alt="" />
                    ) : null}
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td
                style={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  padding: "4px 0px 2px 0px",
                }}
              >
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span>{props.copy}</span>
                  <span
                    style={{
                      border: "1px solid #000000",
                      padding: "3px 5px",
                      fontWeight: "bold",
                    }}
                  >
                    <strong>Kuickpay ID # {props.kuickpayId}</strong>
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div style={{ padding: "4px 0px 4px 0px" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", position: 'relative' }} cellSpacing={2} cellPadding={2}>
          <tbody>
            <tr>
              <td style={{ border: "1px solid #000000", width: "90px" }}>Challan No</td>
              <td style={{ border: "1px solid #000000", fontWeight: "bold" }}>
                {props.challanNo || ""}
              </td>
              <td style={{ border: "1px solid #000000", width: "70px" }}>Month</td>
              <td style={{ border: "1px solid #000000", fontWeight: "bold" }}>
                {props.monthDate ? moment(props.monthDate).format("MMM,YYYY") : ""}
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000000", width: "90px" }}>Registration No</td>
              <td style={{ border: "1px solid #000000", fontWeight: "bold" }} colSpan={3}>
                <strong>{props.admissionNo}</strong>
              </td>
              {props.copy === 'Office Copy' &&
                <div
                  style={{ background: "#fff", position: 'absolute', top: '22px', right: '2px', padding: '5px', border: '1px solid #000000', borderRadius: '4px', zIndex: 3 }}
                >

                  <QRCode
                    size={25}
                    style={{
                      height: "auto",
                      maxWidth: "60px",
                      width: "60px",
                    }}
                    value={props.challanNo || ""}
                    viewBox={`0 0 256 256`}
                  />
                </div>
              }
            </tr>
            <tr>
              <td style={{ border: "1px solid #000000" }}>Student's Name</td>
              <td style={{ border: "1px solid #000000", fontWeight: "bold" }} colSpan={3}>
                {props.name}
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000000" }}>Father's Name</td>
              <td style={{ border: "1px solid #000000", fontWeight: "bold" }} colSpan={3}>
                {props.father}
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000000" }}>Class/Section</td>
              <td style={{ border: "1px solid #000000", fontWeight: "bold" }} colSpan={3}>
                {props.className} {props.section ? `(${props.section})` : ""} {props.wing ? ` ${props.wing}` : ""}
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000000" }}>Issue Date</td>
              <td style={{ border: "1px solid #000000", fontWeight: "bold" }}>
                {/* {props.issueDate ? moment(props.issueDate).format("DD-MMM-YYYY") : ""} */}
                {moment().format("DD-MMM-YYYY")}
              </td>
              <td style={{ border: "1px solid #000000" }}>Due Date</td>
              <td style={{ border: "1px solid #000000", fontWeight: "bold" }}>
                {props.dueDate ? moment(props.dueDate).format("DD-MMM-YYYY") : ""}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div style={{ padding: "4px 0px 4px 0px" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }} cellSpacing={2} cellPadding={2}>
          <tbody>
            <tr>
              <td
                style={{
                  border: "1px solid #000000",
                  backgroundColor: "#d9d9d9",
                  fontWeight: "bold",
                  padding: "3px",
                }}
              >
                Particulars
              </td>
              <td
                style={{
                  border: "1px solid #000000",
                  backgroundColor: "#d9d9d9",
                  fontWeight: "bold",
                  width: "80px",
                  textAlign: "right",
                  padding: "3px",
                }}
              >
                Amount
              </td>
            </tr>
            {renderFeeDetail()}
            <tr>
              <td style={{ border: "1px solid #000000", fontWeight: "bold", padding: "3px" }}>
                <strong>Total Amount</strong>
              </td>
              <td
                style={{
                  border: "1px solid #000000",
                  fontWeight: "bold",
                  textAlign: "right",
                  padding: "3px",
                }}
              >
                <strong>{formatAmount(totalAmount)}</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div style={{ padding: "4px 0px 0px 0px" }}>
        <div style={{ borderTop: "1px dashed #000", margin: "4px 0" }}></div>
        <div style={{ fontWeight: "bold", marginBottom: "4px" }}>
          The Bank of Punjab (Any Branch)
        </div>
        <div style={{ border: "1px solid #000000", padding: "4px", fontSize: "10px" }}>
          <div>
            {props.bank && props.bank}
          </div>
        </div>
        {/* {accountData ? (
          <div style={{ border: "1px solid #000000", padding: "4px", fontSize: "10px" }}>
            <div>
              <strong>Account No</strong> {maskAccountNumber(accountData.accountNumber)}
            </div>
            <div>
              <strong>Account Title</strong> {accountData.accountTitle}
            </div>
          </div>
        ) : (
          <div style={{ border: "1px solid #000000", padding: "4px", fontSize: "10px" }}>
            <div><strong>Account No</strong> 6580125****00017</div>
            <div><strong>Account Title</strong> DISTRICT JINNAH PUBLIC SCHOOL TRUST</div>
          </div>
        )} */}

        <div style={{ marginTop: "4px", fontWeight: "bold" }}>
          Fees can be paid through any "Kuickpay" channels.
        </div>
        <div style={{ marginTop: "4px" }}>
          Online Banking: Jazzcash app, Easypaisa app, HBL, Meezan, MCB, UBL and all other 1Link online banking channels.
        </div>
        <div style={{ marginTop: "4px" }}>
          <div style={{ fontWeight: "bold" }}>Kuickpay Charges:</div>
          <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "3px" }}>
            <tbody>
              <tr>
                <td style={{ border: "1px solid #000000", padding: "2px", textAlign: "center" }}>
                  10,000
                </td>
                <td style={{ border: "1px solid #000000", padding: "2px", textAlign: "center" }}>
                  100,000
                </td>
                <td style={{ border: "1px solid #000000", padding: "2px", textAlign: "center" }}>
                  250,000
                </td>
              </tr>
              <tr>
                <td style={{ border: "1px solid #000000", padding: "2px", textAlign: "center" }}>
                  Rs. 40
                </td>
                <td style={{ border: "1px solid #000000", padding: "2px", textAlign: "center" }}>
                  Rs. 70
                </td>
                <td style={{ border: "1px solid #000000", padding: "2px", textAlign: "center" }}>
                  Rs. 100
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style={{ marginTop: "4px", textAlign: "center" }}>
          Powered By: www.maimasoft.com
        </div>
      </div>
    </>
  );
}

export default StudentInfo;
